import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { PaginatedRequest, PaginatedResponse } from '@/types';
import { API_INVENTORY_URL } from '@/utils';
import { TypeApi } from '../models';

const typesService = createApi({
  reducerPath: 'typesService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/asset-types`),
  tagTypes: ['Types'],
  endpoints: (builder) => ({
    getTypes: builder.query<
      PaginatedResponse<TypeApi>,
      { search?: string; paginated: PaginatedRequest }
    >({
      query: ({ search, paginated }) => {
        const params: any = {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
        };

        if (search && search.trim() !== '') {
          params.name = search.trim();
        }

        return {
          url: '',
          params,
        };
      },
      providesTags: ['Types'],
    }),
    createType: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Types'],
    }),
    updateType: builder.mutation({
      query: ({ typeId, body }) => ({
        url: `/${typeId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Types'],
    }),
  }),
});

export const {
  useGetTypesQuery,
  useCreateTypeMutation,
  useUpdateTypeMutation,
} = typesService;

export default typesService;
